module.exports = __webpack_public_path__ + "img/_SDI9220-2.a43b038d.jpg";